import { Globe } from 'lucide-react';
import type { Product } from './types';
import { normalizeProductPricing } from './pricingNormalization';

export const globalEmployerOfRecord: Product = normalizeProductPricing({
  id: 'global-employer-of-record',
  title: 'Global Employer of Record Platform',
  subtitle: 'AI-powered international expansion & compliance',
  description: 'Next-generation EoR platform with predictive compliance AI, real-time regulation monitoring across 200+ countries, and autonomous global payroll management for seamless international expansion, optimised for UK-based companies expanding globally.',
  icon: Globe,
  image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  category: 'Human Resources',
  status: 'Live',
  features: [
    'AI-Powered Compliance Engine with 98% accuracy for UK Companies',
    'Real-time regulation monitoring across 200+ countries with UK focus',
    'Predictive penalty avoidance system for global compliance',
    'Autonomous contract generation and updates with UK legal standards',
    'Smart payroll processing with crypto options & UK banking integration',
    'Multi-currency management with hedging',
    'Contextual payslips with AI explanations',
    'Living wage adjustment algorithms',
    'Adaptive benefits marketplace',
    'Geo-contextual benefit packages',
    'Global wellness wallet (120+ countries)',
    'Portable HSA funds management',
    'Talent Match AI for optimal hiring locations',
    'Risk simulation with Monte Carlo modeling',
    'Negotiation coaching with ML insights',
    'MENA specialization (WPS, MOHRE, Qiwa)',
    'LATAM optimization (Aguinaldo, nomad visas)',
    'Blockchain-based audit trails',
    'Zero-trust security architecture',
    'GDPR/PDPL compliance framework',
    'Biometric data anonymization',
    'Real-time compliance scorecards',
    'Automated regulatory filing',
    'Multi-language support (25+ languages)',
    'Role-specific dashboards and workspaces',
    'No-code workflow builder',
    'Visual onboarding flow editor',
    'Integrated HRIS/ERP connectors (250+)',
    'Low-code workflow studio',
    'API-first architecture',
    'Mobile-first design',
    'Offline capability support',
    'Real-time collaboration tools',
    'Advanced analytics and reporting',
    'Custom compliance reporting',
    'ROI tracking and optimization',
    'Cost center management',
    'Department-wise analytics',
    'Employee lifecycle management',
    'Performance tracking integration',
    'Time and attendance sync',
    'Leave management automation',
    'Expense management integration',
    'Document management system',
    'Digital signature workflows',
    'Automated contract renewals',
    'Compliance calendar management',
    'Risk assessment automation',
    'Audit preparation assistance',
    'Regulatory change notifications',
    'Expert consultation network',
    '24/7 global support coverage',
    'Dedicated customer success managers',
  ],
  pricing: { setup: 35200, monthly: 899 },
  color: 'from-blue-600 to-indigo-600',
  businessTypes: [
    '#employer-of-record',
    '#global-expansion',
    '#international-payroll',
    '#compliance-management',
    '#global-hr',
    '#remote-workforce',
    '#international-hiring',
    '#regulatory-compliance',
    '#multi-country-operations',
    '#global-benefits',
    '#cross-border-employment',
    '#international-tax',
    '#global-mobility',
    '#workforce-management',
    '#international-law',
  ],
});
